<app-button-outline
  [action]="rejectAction"
  [isHighlight]="false"
  [typeOfButton]="ButtonOutline[1]"
></app-button-outline>
<div class="spinner-Overlay" *ngIf="displaySpinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>